<div class="td-wb-modal-notification-wrapper">

  @if (currentPage() === 0) {
    <div class="td-wb-modal-notification">
      <div class="td-wb-modal-notification__row">
        <div class="td-wb-modal-notification__left">
          <h2 id="td-wb-modal-notification-welcome-modal-fp-pia-page1-header"
              class="td-wb-modal-notification__header">
            <span translate="tdWb.modalNotification.welcomeModalFpPia.page1.HEADER"></span>
          </h2>
          <p class="td-wb-modal-notification__copy"
             translate="tdWb.modalNotification.welcomeModalFpPia.page1.COPY_1"></p>
          <p class="td-wb-modal-notification__copy"
             translate="tdWb.modalNotification.welcomeModalFpPia.page1.COPY_2"></p>
          <p class="td-wb-modal-notification__copy"
             translate="tdWb.modalNotification.welcomeModalFpPia.page1.COPY_3"></p>
          <p class="td-wb-modal-notification__copy"
             translate="tdWb.modalNotification.welcomeModalFpPia.page1.COPY_4"></p>
        </div>
        <div class="td-wb-modal-notification__right td-wb-modal-notification__image-hide">
          <img tdWbModalNotificationImage
               [src]="'tdWb.modalNotification.welcomeModalFpPia.page1.IMAGE_1' | translate"
               [attr.alt]="'tdWb.modalNotification.welcomeModalFpPia.page1.IMAGE_ALT' | translate"
               aria-hidden="true">
        </div>
      </div>
    </div>
  }

  @if (currentPage() === 1) {
    <div class="td-wb-modal-notification">
      <div class="td-wb-modal-notification__row">
        <div class="td-wb-modal-notification__left">
          <h2 id="td-wb-modal-notification-welcome-modal-fp-pia-page2-header"
              class="td-wb-modal-notification__header">
            <span translate="tdWb.modalNotification.welcomeModalFpPia.page2.HEADER"></span>
          </h2>
          <p class="td-wb-modal-notification__copy--bold"
             translate="tdWb.modalNotification.welcomeModalFpPia.page2.COPY_BOLD"></p>
          <p class="td-wb-modal-notification__copy"
             translate="tdWb.modalNotification.welcomeModalFpPia.page2.COPY_1"></p>
          <p class="td-wb-modal-notification__copy"
             translate="tdWb.modalNotification.welcomeModalFpPia.page2.COPY_2"></p>
          <p class="td-wb-modal-notification__copy"
             translate="tdWb.modalNotification.welcomeModalFpPia.page2.COPY_3"></p>
          <p class="td-wb-modal-notification__copy"
             translate="tdWb.modalNotification.welcomeModalFpPia.page2.COPY_4"></p>
        </div>
        <div class="td-wb-modal-notification__right td-wb-modal-notification__image-hide">
          <img tdWbModalNotificationImage
               [src]="'tdWb.modalNotification.welcomeModalFpPia.page2.IMAGE_1' | translate"
               [attr.alt]="'tdWb.modalNotification.welcomeModalFpPia.page2.IMAGE_ALT_1' | translate"
               aria-hidden="true">
          <br>
          <img tdWbModalNotificationImage
               [src]="'tdWb.modalNotification.welcomeModalFpPia.page2.IMAGE_2' | translate"
               [attr.alt]="'tdWb.modalNotification.welcomeModalFpPia.page2.IMAGE_ALT_2' | translate"
               aria-hidden="true">
        </div>
      </div>
    </div>
  }

  @if (currentPage() === 2) {
    <div class="td-wb-modal-notification">
      <div class="td-wb-modal-notification__row td-wb-modal-notification__row--with-border">
        <div class="td-wb-modal-notification__left">
          <h2 id="td-wb-modal-notification-welcome-modal-fp-pia-page3-section1-header"
              class="td-wb-modal-notification__header">
            <span translate="tdWb.modalNotification.welcomeModalFpPia.page3.section1.HEADER"></span>
          </h2>
          <p class="td-wb-modal-notification__copy--bold"
             translate="tdWb.modalNotification.welcomeModalFpPia.page3.section1.COPY_BOLD"></p>
          <p class="td-wb-modal-notification__copy"
             translate="tdWb.modalNotification.welcomeModalFpPia.page3.section1.COPY_1"></p>
        </div>
        <div class="td-wb-modal-notification__right td-wb-modal-notification__image-hide">
          <img tdWbModalNotificationImage
               [src]="'tdWb.modalNotification.welcomeModalFpPia.page3.section1.IMAGE_1' | translate"
               [attr.alt]="'tdWb.modalNotification.welcomeModalFpPia.page3.section1.IMAGE_ALT' | translate"
               aria-hidden="true">
        </div>
      </div>
      <div class="td-wb-modal-notification__row">
        <div class="td-wb-modal-notification__right td-wb-modal-notification__image-hide">
          <img tdWbModalNotificationImage
               [src]="'tdWb.modalNotification.welcomeModalFpPia.page3.section2.IMAGE_2' | translate"
               [attr.alt]="'tdWb.modalNotification.welcomeModalFpPia.page3.section2.IMAGE_ALT' | translate"
               aria-hidden="true">
        </div>
        <div class="td-wb-modal-notification__left">
          <h2 id="td-wb-modal-notification-welcome-modal-fp-pia-page3-section2-header"
              class="td-wb-modal-notification__header">
            <span translate="tdWb.modalNotification.welcomeModalFpPia.page3.section2.HEADER"></span>
          </h2>
          <p class="td-wb-modal-notification__copy--bold"
             translate="tdWb.modalNotification.welcomeModalFpPia.page3.section2.COPY_BOLD"></p>
          <p class="td-wb-modal-notification__copy"
             translate="tdWb.modalNotification.welcomeModalFpPia.page3.section2.COPY_1"></p>
        </div>
      </div>
    </div>
  }

  @if (currentPage() === 3) {
    <div class="td-wb-modal-notification">
      <div class="td-wb-modal-notification__row td-wb-modal-notification__row--with-border">
        <div class="td-wb-modal-notification__left">
          <h2 id="td-wb-modal-notification-welcome-modal-fp-pia-page4-section1-header"
              class="td-wb-modal-notification__header">
            <span translate="tdWb.modalNotification.welcomeModalFpPia.page4.section1.HEADER"></span>
          </h2>
          <p class="td-wb-modal-notification__copy"
             translate="tdWb.modalNotification.welcomeModalFpPia.page4.section1.COPY_1"></p>
        </div>
        <div class="td-wb-modal-notification__right td-wb-modal-notification__image-hide">
          <img tdWbModalNotificationImage
               [src]="'tdWb.modalNotification.welcomeModalFpPia.page4.section1.IMAGE' | translate"
               [attr.alt]="'tdWb.modalNotification.welcomeModalFpPia.page4.section1.IMAGE_ALT' | translate"
               aria-hidden="true">
        </div>
      </div>
      <div class="td-wb-modal-notification__row">
        <div class="td-wb-modal-notification__right td-wb-modal-notification__image-hide">
          <img tdWbModalNotificationImage
               [src]="'tdWb.modalNotification.welcomeModalFpPia.page4.section2.IMAGE' | translate"
               [attr.alt]="'tdWb.modalNotification.welcomeModalFpPia.page4.section2.IMAGE_ALT' | translate"
               style="width:528px"
               aria-hidden="true">
        </div>
        <div class="td-wb-modal-notification__left">
          <h2 id="td-wb-modal-notification-welcome-modal-fp-pia-page4-section2-header"
              class="td-wb-modal-notification__header">
            <span translate="tdWb.modalNotification.welcomeModalFpPia.page4.section2.HEADER"></span>
          </h2>
          <p class="td-wb-modal-notification__copy"
             translate="tdWb.modalNotification.welcomeModalFpPia.page4.section2.COPY_1"></p>
        </div>
      </div>
    </div>
  }

  @if (currentPage() === 4) {
    <div class="td-wb-modal-notification">
      <div class="td-wb-modal-notification__row td-wb-modal-notification__row--with-border">
        <div class="td-wb-modal-notification__left">
          <h2 id="td-wb-modal-notification-welcome-modal-fp-pia-page5-section1-header"
              class="td-wb-modal-notification__header">
            <span translate="tdWb.modalNotification.welcomeModalFpPia.page5.section1.HEADER"></span>
          </h2>
          <p class="td-wb-modal-notification__copy"
             translate="tdWb.modalNotification.welcomeModalFpPia.page5.section1.COPY_1"></p>
          <p class="td-wb-modal-notification__copy"
             translate="tdWb.modalNotification.welcomeModalFpPia.page5.section1.COPY_2"></p>
        </div>
        <div class="td-wb-modal-notification__right td-wb-modal-notification__image-hide">
          <img tdWbModalNotificationImage
               [src]="'tdWb.modalNotification.welcomeModalFpPia.page5.section1.IMAGE' | translate"
               [attr.alt]="'tdWb.modalNotification.welcomeModalFpPia.page5.section1.IMAGE_ALT' | translate"
               aria-hidden="true">
        </div>
      </div>
      <div class="td-wb-modal-notification__row">
        <div class="td-wb-modal-notification__left td-wb-modal-notification__image-hide">
          <img tdWbModalNotificationImage
               [src]="'tdWb.modalNotification.welcomeModalFpPia.page5.section2.IMAGE' | translate"
               [attr.alt]="'tdWb.modalNotification.welcomeModalFpPia.page5.section2.IMAGE_ALT' | translate"
               aria-hidden="true">
        </div>
        <div class="td-wb-modal-notification__right">
          <h2 id="td-wb-modal-notification-welcome-modal-fp-pia-page5-section2-header"
              class="td-wb-modal-notification__header">
            <span translate="tdWb.modalNotification.welcomeModalFpPia.page5.section2.HEADER"></span>
          </h2>
          <p class="td-wb-modal-notification__copy"
             translate="tdWb.modalNotification.welcomeModalFpPia.page5.section2.COPY_1"></p>
        </div>
      </div>
    </div>
  }

  @if (currentPage() === 5) {
    <div class="td-wb-modal-notification-responsive td-wb-modal-notification__container td-wb-modal-notification__copy">
      <h1 class="td-wb-modal-notification-responsive__header">
        <span translate="tdWb.modalNotification.welcomeModalFpPia.page6.HEADER"></span>
      </h1>
      <div>
        <h2 id="td-wb-modal-notification-welcome-modal-fp-pia-page6-section1-subheader"
            class="td-wb-modal-notification-responsive__subheader">
          <span translate="tdWb.modalNotification.welcomeModalFpPia.page6.section1.SUB_HEADER"></span>
        </h2>
        <ul class="td-wb-ul td-wb-ul--basic td-wb-modal-notificiation-responsive__list">
          <li translate="tdWb.modalNotification.welcomeModalFpPia.page6.section1.ITEM_1"></li>
        </ul>
      </div>
      <div>
        <h2 id="td-wb-modal-notification-welcome-modal-fp-pia-page6-section2-subheader"
            class="td-wb-modal-notification-responsive__subheader">
          <span translate="tdWb.modalNotification.welcomeModalFpPia.page6.section2.SUB_HEADER"></span>
        </h2>
        <ul class="td-wb-ul td-wb-ul--basic td-wb-modal-notificiation-responsive__list">
          <li translate="tdWb.modalNotification.welcomeModalFpPia.page6.section2.ITEM_1"></li>
          <li translate="tdWb.modalNotification.welcomeModalFpPia.page6.section2.ITEM_2"></li>
        </ul>
      </div>
      <div class="td-wb-modal-notification__container--image-container">
        <img tdWbModalNotificationImage
             class="td-wb-modal-notification__container--image"
             [src]="'tdWb.modalNotification.welcomeModalFpPia.page6.IMAGE' | translate"
             [attr.alt]="'tdWb.modalNotification.welcomeModalFpPia.page6.IMAGE_ALT' | translate"
             aria-hidden="true">
      </div>
    </div>
  }
</div>
